import './job-search-filter.scss';

import Autocomplete from '@trevoreyre/autocomplete-js';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import '@trevoreyre/autocomplete-js/dist/style.css';

class JobSearchFilter {
    constructor ($element) {
        this.$jobSearchFilter = $element;
        this.$filterToggle = this.$jobSearchFilter.querySelector('[data-job-search-filter="toggle"]');
        this.$filterSearchLocationWrapper = this.$jobSearchFilter.querySelector('[data-job-search-filter="search-location-wrapper"]');
        this.$$filterTags = this.$jobSearchFilter.querySelectorAll('[data-job-search-filter="tag"]');
        this.$$filterOptions = this.$jobSearchFilter.querySelectorAll('[data-job-search-filter="option"]');
        this.$$filterOptionsToggle = this.$jobSearchFilter.querySelectorAll('[data-job-search-filter="options-toggle"]');
        this.$rangeSlider = this.$jobSearchFilter.querySelector('[data-job-search-filter="range-slider"]');
        this.$filterForm = this.$jobSearchFilter.querySelector('[data-job-search-filter="form"]');
        this.activeState = false;
        this.deactivateToggle = false;

        this.initialize();
    }

    initialize () {
        this.activeState = window.mediaMatchHandler[1024].matches;
        this.deactivateToggle = window.mediaMatchHandler[1024].matches;
        this.setMainFilterActive();

        window.mediaMatchHandler[1024].addEventListener('change', (match) => {
            this.activeState = match.matches;
            this.deactivateToggle = match.matches;
            this.setMainFilterActive();
        });

        this.$filterToggle.onclick = () => {
            this.activeState = this.activeState === false ? true : false;
            this.setMainFilterActive();
        };

        if (this.$$filterTags.length > 0) {
            this.$$filterTags.forEach($filterTags => {
                $filterTags.onclick = () => {
                    this.setQueryParams($filterTags.dataset.selectedTagValue, [$filterTags.dataset.selectedTagOption], true);
                };
            });
        }

        if (this.$$filterOptionsToggle.length > 0) {
            this.$$filterOptionsToggle.forEach($filterOptionsToggle => {
                let optionsActiveState = false;

                $filterOptionsToggle.onclick = () => {
                    optionsActiveState = !optionsActiveState;
                    $filterOptionsToggle.setAttribute('aria-expanded', optionsActiveState);
                };
            });
        }

        if (this.$$filterOptions.length > 0) {
            this.$$filterOptions.forEach($filterOption => {
                this.handleFilterOption($filterOption);
            });
        }

        if (this.$rangeSlider) {
            this.initRangeSlider();
        }

        if (this.$filterSearchLocationWrapper) {
            this.initAutoComplete();
        }

        if (this.$filterForm) {
            this.$filterForm.onsubmit = (e) => {
                e.preventDefault();
                this.submitFilterForm();
            };
        }
    }

    handleFilterOption ($filterOption) {
        const $optionInput = $filterOption.querySelector('[data-option-field]');
        let $optionsData = JSON.parse($optionInput.value);
        const $$optionCheckboxes = $filterOption.querySelectorAll('[data-option-checkbox]');

        if ($$optionCheckboxes.length > 0) {
            $$optionCheckboxes.forEach($optionCheckbox => {
                $optionCheckbox.onchange = () => {
                    if ($optionInput) {
                        if ($optionCheckbox.checked === true) {
                            $optionsData.push($optionCheckbox.value);
                        } else {
                            $optionsData = $optionsData.filter(optionId => optionId !== $optionCheckbox.value);
                        }

                        $optionInput.value = JSON.stringify($optionsData);

                        if ($optionsData.length > 0) {
                            $optionInput.setAttribute('name', $optionInput.dataset.optionFieldName);
                        } else if ($optionInput.hasAttribute('name')) {
                            $optionInput.removeAttribute('name');
                        }
                    }
                };
            });

            if ($optionsData.length > 0) {
                $optionInput.setAttribute('name', $optionInput.dataset.optionFieldName);
            }
        }
    }

    submitFilterForm () {
        let URLParams = [];
        const formData = new FormData(this.$filterForm);

        formData.forEach((value, key) => {
            if (value) {
                let cleanedValue = value;

                try {
                    const jsonValue = JSON.parse(value);
                    if (Array.isArray(jsonValue)) {
                        cleanedValue = jsonValue;
                    }
                } catch (e) {}

                URLParams.push(`${key}=${cleanedValue}`);
            }
        });

        // we don't need perimeter if city is not set
        if (!URLParams.some(param => param.startsWith('city='))) {
            URLParams = URLParams.filter(param => !param.startsWith('perimeter='));
        }

        const submitURL = URLParams.length ? `?${URLParams.join('&')}` : location.pathname;
        history.replaceState(history.state, '', submitURL.toString());
        location.reload();
    }

    setQueryParams (param, values, remove = false) {
        const urlObject = new URL(window.location);

        if (remove === true) {
            const currentParams = urlObject.searchParams.get(param);
            const cleanedParams = currentParams.split(',').filter(value => value !== values.toString()).join(','); // remove value from param

            if (cleanedParams !== '') {
                urlObject.searchParams.set(param, cleanedParams);
            } else {
                urlObject.searchParams.delete(param);

                // we don't need perimeter if city is not set
                if (param === 'city') {
                    urlObject.searchParams.delete('perimeter');
                }
            }
        } else {
            urlObject.searchParams.set(param, values);
        }

        history.replaceState(history.state, '', urlObject.toString());
        location.reload();
    }

    setMainFilterActive () {
        if (this.deactivateToggle === true) {
            this.$filterToggle.setAttribute('disabled', 'disabled');
            this.$filterToggle.setAttribute('role', 'presentation');
            this.$filterToggle.removeAttribute('aria-expanded');
        } else if (this.$filterToggle.hasAttribute('disabled')) {
            this.$filterToggle.removeAttribute('disabled');
            this.$filterToggle.removeAttribute('role');
        }

        if (this.deactivateToggle === false) {
            this.$filterToggle.setAttribute('aria-expanded', this.activeState);
        }
    }

    initRangeSlider () {
        const rangeSliderValueLabel = this.$rangeSlider.dataset.rangeValueLabel;
        let rangeSliderValue = this.$rangeSlider.dataset.rangeValue;
        const $rangeSliderInput = this.$jobSearchFilter.querySelector('[data-job-search-filter="range-input"]');

        let minValue = 0;
        let maxValue = 100;

        if (rangeSliderValue !== '') {
            rangeSliderValue = parseInt(rangeSliderValue);
        } else {
            rangeSliderValue = minValue;
        }

        noUiSlider.create(this.$rangeSlider, {
            start: rangeSliderValue,
            range: {
                'min': minValue,
                'max': maxValue
            },
            handleAttributes: [
                {'aria-label': window.TRANSLATIONS.FILTER.RANGE_SLIDER_LABEL},
            ],
            connect: 'lower',
            step: 1,
            tooltips: {
                to: function (value) {
                    const formatedValue = Math.round(value);
                    return formatedValue + ' ' + rangeSliderValueLabel;
                }
            }
        });

        // we have to remove the name to prevent submit of this input
        const setRangeInputName = () => {
            if ($rangeSliderInput.value === '0' && $rangeSliderInput.hasAttribute('name')) {
                $rangeSliderInput.removeAttribute('name');
            } else if (!$rangeSliderInput.hasAttribute('name')) {
                $rangeSliderInput.setAttribute('name', 'perimeter');
            }
        };

        // init call
        setRangeInputName();

        this.$rangeSlider.noUiSlider.on('update', function (values) {
            values.forEach(value => {
                if ($rangeSliderInput) {
                    $rangeSliderInput.value = parseFloat(value).toFixed(0);
                    setRangeInputName();
                }
            });
        });
    }

    initAutoComplete () {
        const $filterSearchLocationInput = this.$filterSearchLocationWrapper.querySelector('[data-job-search-filter="search-location-input"]');
        const $filterSearchLocationResults = this.$filterSearchLocationWrapper.querySelector('[data-search-autosuggestion-city]');
        const $filterItems = JSON.parse($filterSearchLocationResults.dataset.searchAutosuggestionCity || '[]');

        new Autocomplete(this.$filterSearchLocationWrapper, { // eslint-disable-line
            search: (inputValue) => {
                const searchTerm = inputValue.trim().toLowerCase(); // cleanup search input
                const results = [];

                if (searchTerm.length < 2) {
                    return results;
                } else {
                    $filterItems.forEach((filterItem) => {
                        const cleanedFilterItem = String(filterItem).toLowerCase();

                        if (cleanedFilterItem.includes(searchTerm)) {
                            results.push({title: filterItem});
                        }
                    });

                    return results;
                }
            },
            getResultValue: (result) => result.title,
            onSubmit: (result) => {
                if (result) {
                    this.setQueryParams('city', [result.title]);
                }
            }
        });

        $filterSearchLocationInput.removeAttribute('aria-activedescendant');

        $filterSearchLocationInput.addEventListener('blur', () => {
            $filterSearchLocationInput.removeAttribute('aria-activedescendant');
        });
    }
}

export { JobSearchFilter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$jobSearchFilter = $context.querySelectorAll('[data-job-search-filter="root"]');

    if ($$jobSearchFilter.length > 0) {
        $$jobSearchFilter.forEach(($jobSearchFilter) => {
            const jobSearchFilter = new JobSearchFilter($jobSearchFilter); // eslint-disable-line
        });
    }
});